var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "setting-main-container" }, [
    _c("div", { staticClass: "card setting-card" }, [
      _c("div", { staticClass: "page-header" }, [
        _c("h3", { staticClass: "page-title" }, [
          _vm._v(_vm._s(_vm.$t("customers.basic_info"))),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-md-6 mb-4" }, [
          _c("label", { staticClass: "form-label" }, [
            _vm._v(_vm._s(_vm.$t("customers.display_name"))),
          ]),
          _vm._v(" "),
          _vm.viewCustomer && _vm.viewCustomer.name != null
            ? _c("p", [_vm._v(_vm._s(_vm.viewCustomer.name))])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-6 mb-4" }, [
          _c("label", { staticClass: "form-label" }, [
            _vm._v(_vm._s(_vm.$t("customers.primary_contact_name"))),
          ]),
          _vm._v(" "),
          _vm.viewCustomer && _vm.viewCustomer.contact_name != null
            ? _c("p", [_vm._v(_vm._s(_vm.viewCustomer.contact_name))])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-6 mb-4" }, [
          _c("label", { staticClass: "form-label" }, [
            _vm._v(_vm._s(_vm.$t("customers.email"))),
          ]),
          _vm._v(" "),
          _vm.viewCustomer && _vm.viewCustomer.email != null
            ? _c("p", [_vm._v(_vm._s(_vm.viewCustomer.email))])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-6 mb-4" }, [
          _c("label", { staticClass: "form-label" }, [
            _vm._v(_vm._s(_vm.$t("customers.phone"))),
          ]),
          _vm._v(" "),
          _vm.viewCustomer && _vm.viewCustomer.phone != null
            ? _c("p", [_vm._v(_vm._s(_vm.viewCustomer.phone))])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-6 mb-4" }, [
          _c("label", { staticClass: "form-label" }, [
            _vm._v(_vm._s(_vm.$t("customers.primary_currency"))),
          ]),
          _vm._v(" "),
          _vm.viewCustomer && _vm.viewCustomer.currency != null
            ? _c("p", [
                _vm._v(
                  _vm._s(_vm.viewCustomer.currency.code) +
                    "-" +
                    _vm._s(_vm.viewCustomer.currency.name)
                ),
              ])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-6 mb-4" }, [
          _c("label", { staticClass: "form-label" }, [
            _vm._v(_vm._s(_vm.$t("customers.website"))),
          ]),
          _vm._v(" "),
          _vm.viewCustomer && _vm.viewCustomer.website != null
            ? _c("p", [_vm._v(_vm._s(_vm.viewCustomer.website))])
            : _vm._e(),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }